<template>
  <div aria-label="Errors" class="fixed right-4 top-8 z-[99]">
    <TransitionGroup name="list">
      <button
        v-for="notification in notifications"
        :key="notification.id"
        type="button"
        class="fixed right-4 top-8 w-96 gap-2 rounded px-6 py-4 text-left text-sm font-semibold shadow-md"
        :class="{
          'bg-surface-500 text-violet-text-dark': notification.type === 'info',
          'bg-notification-error text-white': notification.type === 'error',
        }"
        aria-live="assertive"
        @click="dismiss(notification)"
      >
        <h2 class="mb-1 typo-heading-s-semibold">
          {{ notification.title }}
          <IconCross class="float-right mt-1 w-4" />
        </h2>
        <p class="typo-body-m-medium">
          {{ notification.text }}
        </p>
      </button>
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
const { notifications, dismiss } = useNotification()
</script>
